<template lang="pug">
  SspLayout(area="tnt")
    template(slot="actions")
      router-link.btn.btn-primary.new-business-location(:to="{ name: 'newBusinessLocation'}")
        i.fa.fa-plus
        span.ml5 New
    .row
      .col-md-12
        DataGrid(ref="grid" :fetch="listLocations" @error="$emit('error', $event)" url-page-param="page")
          tr(slot="thead")
            th Id
            th Name
            th Category
            th City
            th ZipCode
            th GLN
            th Parent id
            th
          tr(v-for="l in locations")
            td {{l.id}}
            td {{l.name}}
            td {{l.category}}
            td {{l.city}}
            td {{l.zipCode}}
            td {{l.gln}}
            td(class="clickable" @click="goToParentLocation(l.parentLocationId)") {{l.parentLocationId}}
            td.actions
              router-link.btn-edit(title="Edit" :to="{ name: 'editBusinessLocation', params: {id: l.id}}")
              a.btn-trash(title="Delete Business Location" @click="deleteBusinessLocation(l.id)")
</template>

<script>
import miniToastr from 'mini-toastr'
import DataGrid from '@/components/ssp/DataGrid'
import TrackNTrace from '@/service/apis/TrackNTrace'

export default {
  data: () => ({
    center: { lat: 0, lng: 0 },
    locations: [],
    location: {},
    markers: []
  }),
  methods: {
    listLocations(page) {
      const req = page.pageRequest()
      return TrackNTrace.listBusinessLocations(req)
        .then((r) => {
          this.locations = r.data.content
          return r.data.totalElements
        })
        .catch((e) => { this.$emit('error', e) })
    },
    goToParentLocation(id) {
      this.$router.push(`/trackntrace/business-locations/${id}`)
    },
    deleteBusinessLocation(id) {
      this.$confirm({ text: 'Are you sure you want to delete this business location?' })
        .then((conf) => {
          if (conf) {
            TrackNTrace.deleteBusinessLocation(id)
              .then(() => {
                miniToastr.success(`Business location ${id} was deleted`)
                this.$refs.grid.reload()
              })
              .catch((e) => { this.$emit('error', e) })
          }
        })
    }
  },
  components: {
    DataGrid
  }
}
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/BusinessLocations.vue